<div class="fieldset"
     [ngClass]="{'disabled' : berthVisit.ata || berthVisit.atd || isBerthOfTransfer || (berthVisit.terminalPlanningEnabled && berthVisit.berth)}">
  <app-form-group>
    @if (berthVisit.terminalPlanningEnabled && berthVisit.berth) {
      <app-info class="formGroupLabel">
        <label>Berth</label>
        <div class="tooltipContent">Berth is automatically defined based on planning retrieved from the terminal</div>
      </app-info>
    } @else {
      <label>Berth</label>
    }

    <app-search [(ngModel)]="berthVisit.berth" [searchFunction]="searchBerth" [inputFormatter]="berthInputFormatter"
                (ngModelChange)="onBerthChanged($event)" required
                [disabled]="disabled"
                placeholder="Find berth or buoy" dataKey="name">
    </app-search>
    <div class="invalid-feedback">Please select a berth</div>
  </app-form-group>
</div>
